<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

function checkBuyButtonState() {
  let topVariant = '';
  let bottomVariant = '';
  
  // Get checked radio for Top (option 1)
  var topRadio = $('.product-form__input[data-option-index="1"] input[type="radio"][checked]');
  if (topRadio.length) {
    topVariant = topRadio.val()
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }
  
  // Get checked radio for Bottom (option 2)
  var bottomRadio = $('.product-form__input[data-option-index="2"] input[type="radio"][checked]');
  if (bottomRadio.length) {
    bottomVariant = bottomRadio.val()
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }
  
  console.log('Top:', topVariant, 'Bottom:', bottomVariant);
  
  var $buttons = $('.productView-action .button, .shopify-payment-button__button, .shopify-payment-button');
  var $dynamicCheckoutContainer = $('.shopify-payment-button, [data-shopify="payment-button"]');
  
  if (topVariant === 'no-top' && bottomVariant === 'no-bottom') {
    $buttons
      .addClass('disabled-buy-buttons')
      .prop('disabled', true)
      .attr('aria-disabled', 'true');
    
    // Disable dynamic checkout with pointer-events only (no visual change)
    $dynamicCheckoutContainer.css('pointer-events', 'none');
    
  } else {
    $buttons
      .removeClass('disabled-buy-buttons')
      .prop('disabled', false)
      .removeAttr('aria-disabled');
    
    // Re-enable dynamic checkout
    $dynamicCheckoutContainer.css('pointer-events', 'auto');
  }
}

// ✅ Keep radios properly marked as checked
$(document).on('change', '.product-form__input input[type="radio"]', function() {
  var $this = $(this);
  var name = $this.attr('name');
  $('input[name="' + name + '"]').removeAttr('checked');
  $this.attr('checked', 'checked');
  checkBuyButtonState();
});

// ✅ On page load
$(document).ready(function() {
  checkBuyButtonState();
});

// ✅ Re-apply after dynamic Shopify reloads (Ella does this)
document.addEventListener('shopify:section:load', checkBuyButtonState);
document.addEventListener('shopify:section:select', checkBuyButtonState);
document.addEventListener('shopify:section:deselect', checkBuyButtonState);

// ✅ Also reapply when Shopify replaces Buy Now iframe/button
setInterval(() => {
  checkBuyButtonState();
}, 1000);



// jQuery(document).ready(function($) {
  
//   console.log('🎨 Custom Price Script: Initializing');
  
//   // Debounce variables
//   let variantChangeTimeout = null;
  
//   // Cache the discount percentage on load
//   let cachedDiscountPercentage = null;
  
//   // Flag to track if animation is in progress
//   let isAnimating = false;
  
//   // Function to get discount percentage with fallback
//   function getDiscountPercentage() {
//     // Try to get from DOM
//     const domDiscount = parseFloat($('.product-details').attr('discounted_percentage'));
    
//     if (!isNaN(domDiscount) && domDiscount > 0) {
//       // Cache it for future use
//       cachedDiscountPercentage = domDiscount;
//       console.log('📊 Discount percentage from DOM:', domDiscount);
//       return domDiscount;
//     }
    
//     // Fall back to cached value
//     if (cachedDiscountPercentage !== null) {
//       console.log('📊 Using cached discount percentage:', cachedDiscountPercentage);
//       return cachedDiscountPercentage;
//     }
    
//     console.log('📊 No discount percentage found, using 0');
//     return 0;
//   }
  
//   // Function to format price as "CAD 3,570" or "CAD 12.50"
//   function formatMoney(cents) {
//     const dollars = cents / 100;
    
//     // Check if there are actual cents (not .00)
//     const hasCents = cents % 100 !== 0;
    
//     const formatted = dollars.toLocaleString('en-CA', {
//       minimumFractionDigits: hasCents ? 2 : 0,
//       maximumFractionDigits: hasCents ? 2 : 0
//     });
//     return 'CAD ' + formatted;
//   }
  
//   // Function to apply custom discount
//   function applyCustomDiscount(price, discountPercentage) {
//     if (discountPercentage > 0) {
//       const discountMultiplier = (100 - discountPercentage) / 100;
//       return Math.round(price * discountMultiplier);
//     }
//     return price;
//   }
  
//   // Function to animate price change with blur effect
//   function animatePriceChange($element, newText) {
//     // Only animate if not already animating
//     if (isAnimating) {
//       $element.text(newText);
//       return;
//     }
    
//     isAnimating = true;
    
//     // Add blur-out animation to the price container
//     $('.productView-price .price').css({
//       'filter': 'blur(4px)',
//       'transition': 'filter 0.9s ease-out'
//     });
    
//     // Change text and blur-in after short delay
//     setTimeout(function() {
//       $element.text(newText);
//       $('.productView-price .price').css({
//         'filter': 'blur(0px)',
//         'transition': 'filter 0.9s ease-in'
//       });
      
//       // Clean up inline styles after animation
//       setTimeout(function() {
//         $('.productView-price .price').css({
//           'filter': '',
//           'transition': ''
//         });
//         isAnimating = false;
//       }, 900);
//     }, 900);
//   }
  
//   // Function to update price display
//   function updatePriceDisplay(variantId) {
//     // Get discount percentage using fallback logic
//     const discountPercentage = getDiscountPercentage();
    
//     console.log('💰 Updating price for variant:', variantId);
//     console.log('📊 Active discount percentage:', discountPercentage);
    
//     // Fetch variant data from Shopify API
//     const productHandle = window.location.pathname.split('/products/')[1].split('?')[0];
    
//     $.ajax({
//       url: '/products/' + productHandle + '.js',
//       type: 'GET',
//       dataType: 'json',
//       success: function(product) {
//         console.log('📦 Product data received');
        
//         // Find the selected variant
//         const selectedVariant = product.variants.find(v => v.id == variantId);
        
//         if (selectedVariant) {
//           console.log('✅ Selected variant found:', selectedVariant);
          
//           // Only fetch selling price from variant
//           let originalSellingPrice = selectedVariant.price;
          
//           // Log original selling price from Shopify
//           console.log('🏷️ SELLING PRICE (From Shopify Variant):', formatMoney(originalSellingPrice), '(' + originalSellingPrice + ' cents)');
          
//           let comparePrice, sellingPrice;
          
//           // Apply discount logic
//           if (discountPercentage > 0) {
//             // Original selling price becomes compare price
//             comparePrice = originalSellingPrice;
//             // Apply discount to get new selling price
//             sellingPrice = applyCustomDiscount(originalSellingPrice, discountPercentage);
//             console.log('✂️ Applying custom discount of ' + discountPercentage + '%');
//           } else {
//             // No discount: both prices are same
//             comparePrice = originalSellingPrice;
//             sellingPrice = originalSellingPrice;
//             console.log('ℹ️ No discount applied');
//           }
          
//           console.log('💵 Calculated - Compare:', comparePrice, 'Selling:', sellingPrice);
          
//           // Console log formatted prices for clarity
//           console.log('💰 COMPARE PRICE (Original/Discounted From):', formatMoney(comparePrice), '(' + comparePrice + ' cents)');
//           console.log('💰 SELLING PRICE (Final Price):', formatMoney(sellingPrice), '(' + sellingPrice + ' cents)');
          
//           if (comparePrice > sellingPrice) {
//             const savedAmount = comparePrice - sellingPrice;
//             const percentOff = Math.round(((comparePrice - sellingPrice) / comparePrice) * 100);
//             console.log('💸 SAVINGS:', formatMoney(savedAmount), '(' + percentOff + '% off)');
//           }
          
//           // Update compare price using the exact selector with animation
//           if (comparePrice > sellingPrice) {
//             const $compareElement = $('.price__compare .price-item');
//             animatePriceChange($compareElement, formatMoney(comparePrice));
//             $('.price__sale').show();
//             console.log('✅ Showing compare price and discount');
//           } else {
//             $('.price__sale').hide();
//             console.log('❌ Hiding compare price (no discount)');
//           }
          
//           // Update selling price using the exact selector with animation
//           const $sellingElement = $('.price .price__last .price-item--sale');
//           animatePriceChange($sellingElement, formatMoney(sellingPrice));
//           console.log('💲 Displaying selling price:', formatMoney(sellingPrice));
          
//           // Update saved price if element exists
//           if ($('.price__saved').length) {
//             const savedAmount = comparePrice - sellingPrice;
//             if (savedAmount > 0) {
//               const $savedElement = $('.price__saved .price-item--saved');
//               animatePriceChange($savedElement, 'Save ' + formatMoney(savedAmount));
//               $('.price__saved').show();
//             } else {
//               $('.price__saved').hide();
//             }
//           }
          
//           // Update percentage badge if element exists
//           if ($('.label_sale_percent').length) {
//             if (comparePrice > sellingPrice) {
//               const percentOff = Math.round(((comparePrice - sellingPrice) / comparePrice) * 100);
//               $('.label_sale_percent').text('(-' + percentOff + '%)').show();
//             } else {
//               $('.label_sale_percent').hide();
//             }
//           }
//         }
//       },
//       error: function(xhr, status, error) {
//         console.error('❌ Error fetching product data:', error);
//       }
//     });
//   }
  
//   // Function to get variant ID
//   function getVariantId() {
//     let variantId = null;
    
//     // Method 1: From select dropdown
//     variantId = $('select[name="id"]').val();
//     if (variantId) return variantId;
    
//     // Method 2: From hidden input
//     variantId = $('input[name="id"]').val();
//     if (variantId) return variantId;
    
//     // Method 3: From checked radio button
//     variantId = $('input[name="id"]:checked').val();
//     if (variantId) return variantId;
    
//     // Method 4: From product form radio buttons
//     variantId = $('.product-form__input input[type="radio"]:checked').val();
//     if (variantId) return variantId;
    
//     // Method 5: From URL parameter
//     const urlParams = new URLSearchParams(window.location.search);
//     variantId = urlParams.get('variant');
//     if (variantId) return variantId;
    
//     return null;
//   }
  
//   // Debounced update function
//   function debouncedUpdatePrice(variantId, delay = 300) {
//     if (variantChangeTimeout) {
//       clearTimeout(variantChangeTimeout);
//       console.log('⏸️ Cancelled previous update');
//     }
    
//     console.log('⏳ Debouncing update for variant:', variantId);
    
//     variantChangeTimeout = setTimeout(function() {
//       console.log('▶️ Executing update');
//       updatePriceDisplay(variantId);
//       variantChangeTimeout = null;
//     }, delay);
//   }
  
//   // ============================================
//   // EVENT LISTENER - Radio button change only
//   // ============================================
  
//   $(document).on('change', '.product-form__input input[type="radio"]', function() {
//     console.log('🔘 Radio button changed');
    
//     const variantId = getVariantId();
//     console.log('Variant ID found:', variantId);
    
//     if (variantId) {
//       debouncedUpdatePrice(variantId, 300);
//     }
//   });
  
//   // ============================================
//   // INITIALIZATION
//   // ============================================
  
//   // Initialize discount percentage cache early
//   cachedDiscountPercentage = getDiscountPercentage();
//   console.log('🎬 Initial discount percentage cached:', cachedDiscountPercentage);
  
//   setTimeout(function() {
//     const initialVariantId = getVariantId();
//     console.log('🎬 Initial variant ID:', initialVariantId);
    
//     if (initialVariantId) {
//       updatePriceDisplay(initialVariantId);
//     }
//   }, 500);
  
//   console.log('✅ Custom price script initialized');
  
// });